<template>
  <div>
    <cost-centre-menu></cost-centre-menu>

    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <cost-centre-form @saved="load">
          <v-btn block color="accent">{{ $t("settings.costCentre.newCostButton") }} </v-btn>
        </cost-centre-form>
      </div>
    </v-row>

    <v-data-table :headers="headers" :items="costCentres" :search="search" sort-by="list_order" item-key="id">
      <template #item="{item}">
        <tr>
          <td class="text-left">
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :disabled="item.list_order === 1" @click="moveUp(item)" icon v-on="on">
                  <v-icon>fa-arrow-alt-circle-up</v-icon>
                </v-btn>
              </template>
              {{ $t("global.moveUp") }}
            </v-tooltip>

            {{ item.list_order }}
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :disabled="item.list_order === costCentres.length" @click="moveDown(item)" icon v-on="on">
                  <v-icon>fa-arrow-alt-circle-down</v-icon>
                </v-btn>
              </template>
              {{ $t("global.moveDown") }}
            </v-tooltip>
          </td>
          <td class="text-left">
            {{ item.name }}
          </td>
          <td class="text-left">
            <span v-if="item.is_enabled === 1">{{ $t("global.yes") }}</span>
            <span v-if="item.is_enabled === 0">{{ $t("global.no") }}</span>
          </td>
          <td class=" justify-center align-content-center px-0">
            <span v-if="item.used_in_delegations > 0"
              >{{ $t("settings.costCentre.costEditAppliesNTimes", item.used_in_delegations, { count: item.used_in_delegations }) }} <br
            /></span>
            <span v-if="item.used_in_delegations === 0">{{ $t("settings.costCentre.costZeroTimes") }}<br /></span>
          </td>
          <td class="px-0 text-center">
            <cost-centre-form :cost-centre.sync="item" @saved="load"> </cost-centre-form>
            <v-tooltip bottom v-if="item.used_in_delegations === 0">
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn v-on="on" @click="remove(item)" icon>
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CostCentreMenu from "../../../components/Settings/CostCentre/CostCentreMenu";
import CostCentreForm from "../../../components/Settings/CostCentre/CostCentreForm";
export default {
  name: "SettingsCostCentreView",
  components: { CostCentreForm, CostCentreMenu },
  data: () => ({
    costCentres: [],
    search: ""
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("settings.costCentre.headers.ordinate"),
          value: "list_order",
          sortable: true
        },
        { text: this.$t("global.itemName"), value: "name" },
        {
          text: this.$t("settings.costCentre.headers.isEnabled"),
          value: "is_enabled",
          sortable: false
        },
        { text: " ", value: "actions2", sortable: false },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  methods: {
    load() {
      this.axios.get("settings/cost-centre/list").then(response => {
        this.costCentres = response.data;
      });
    },
    remove(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result.then(() => {
        this.axios.post("settings/cost-centre/delete", { id: item.id }).then(() => {
          this.load();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.deleted")
          });
        });
      });
    },
    moveUp(item) {
      this.axios.post("settings/cost-centre/move-up", { id: item.id }).then(() => {
        this.load();
      });
    },
    moveDown(item) {
      this.axios.post("settings/cost-centre/move-down", { id: item.id }).then(() => {
        this.load();
      });
    }
  },
  created() {
    this.load();
  }
};
</script>

<style scoped></style>
